module.exports = __webpack_public_path__ + "static/img/5.c40ddfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/commonality/20251009/5.jpg
// module id = YcSy
// module chunks = 7